export const GENERAL_API_STALE = 3600000;
export const API_STALE_TIME_5_MINUTES = 5 * 60 * 100;
export const API_STALE_TIME_10_MINUTES = 10 * 60 * 100;
export const API_STALE_TIME_15_MINUTES = 15 * 60 * 100;
